import { useEffect, useMemo } from 'react';
import { ListGroup, Row } from 'shards-react';
import ReferenceListItem from './ReferenceListItem';
import { find } from 'lodash';

const ReferenceChecker = ({ reference, addReference, removeReference, matchingRefs, pattern, closeDropdown }) => {
	const splitedRefs = useMemo(() => 
        Array.isArray(reference) ? 
            reference
            : reference.split(',')
            , [reference]);

	useEffect(() => {
		window.addEventListener('click', closeDropdown);
		return () => window.removeEventListener('click', closeDropdown);
	}, [closeDropdown]);

	return (
		<Row className='h-auto overflow-auto bg-white w-100 ref-list position-absolute p-1 border rounded' noGutters style={{ maxHeight: 450 }}>
			<ListGroup className='pb-1 flex-grow-1'>
				{splitedRefs?.map((reference, index, arr) => {
					const isMatchingPattern = !!find(matchingRefs, { reference }) && new RegExp(pattern).test(reference);
					const duplicateValue = arr.slice(0, index).includes(reference);
					const isValid = isMatchingPattern && !duplicateValue;
					const itemKey = duplicateValue ? `duplicate-${index}` : isValid ? reference : `invalid-${index}`;
					const referenceText = isValid ? reference : !isMatchingPattern ? `${reference} - Referenz ungültig!` : `${reference} - Referenz existiert!`;

					return <ReferenceListItem key={itemKey} reference={referenceText} isChecked={isValid} isInvalid={!isValid} clickHandler={() => removeReference(reference)} />;
				})}
				{matchingRefs
					?.filter(({ reference }) => !splitedRefs.includes(reference))
					.map(({ _id: refId, reference }) => (
						<ReferenceListItem key={refId} reference={reference} clickHandler={() => addReference(reference)} />
					))}
			</ListGroup>
		</Row>
	);
};

export default ReferenceChecker;
